import { SIDE_BAR_TOGGLE, SET_MOBILE_VIEW_STATE, SET_TABLET_VIEW_STATE } from '../Constants/actionTypes';

export const toggleSideBar = () => (dispatch) => dispatch({ type: SIDE_BAR_TOGGLE });
export const setMobileViewState = (state) => (dispatch) => dispatch({ type: SET_MOBILE_VIEW_STATE, payload: state });
export const setTabletViewState = (state) => (dispatch) => dispatch({ type: SET_TABLET_VIEW_STATE, payload: state });
